import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { setSearchText } from "../../../store/profileFormAssigned";
import { RootState } from "../../../store/rootReducer";

export const AssignFormSearchBar = () => {
    const dispatch = useDispatch();
    const searchText = useSelector((store: RootState) => store.profileFormAssigned.searchText);

    return (
        <IonSearchbar
            value={searchText}
            onIonChange={({ detail: { value = "" } }) => {
                dispatch(setSearchText(value));
            }}
            debounce={700}
            placeholder={"Buscar plantilla..."}
            autocomplete="off"
        />
    );
}